import { render } from "./AutoCheckInModuleForm.vue?vue&type=template&id=639e140e"
import script from "./AutoCheckInModuleForm.vue?vue&type=script&lang=js"
export * from "./AutoCheckInModuleForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__